import ResumeHeading from "./ResumeHeading";
import skills from '../skills/data';

const EducationPanel = () => (
    <div className="resume-screen-container education-container">
        <ResumeHeading heading="MCAST" subHeading="Bachelor of Science in Software Development - First Class Honours" fromDate="2014" toDate="2016" />
        <ResumeHeading heading="MCAST" subHeading="BTEC Higher National Diploma in Software Development" fromDate="2012" toDate="2014" />
        <ResumeHeading heading="Sir MichelAngelo Refalo" subHeading="Matriculation Certificate - Advanced Level in Pure Mathematics and Computing" fromDate="2008" toDate="2011" />
    </div>
);

const WorkPanel = () => (
    <div className="resume-screen-container experience-container">
        <ResumeHeading heading="MeDirect Bank Malta" subHeading="Senior Software Developer" fromDate="2023" toDate="Present" />
        <ResumeHeading heading="Betsson Group" subHeading="Senior Backend Developer - Sportsbook" fromDate="2020" toDate="2023" />
        <ResumeHeading heading="Helio Gaming" subHeading="Backend Software Developer" fromDate="2019" toDate="2020" />
        <ResumeHeading heading="Bit8" subHeading="Software Developer" fromDate="2015" toDate="2019" />
    </div>
);

const SkillsPanel = () => (
    <div className="resume-screen-container resume-skills-grid">
        {skills.map(skill => (
            <div key={skill.id} className="resume-skill-item">
                <span className="resume-skill-icon">{skill.icon}</span>
                <small>{skill.name}</small>
            </div>
        ))}
    </div>
);

const ResumeDetails = [WorkPanel, EducationPanel, SkillsPanel];

export default ResumeDetails;